import { SELECTORS, BREAKPOINT, DATA_ATTR, CLASSES } from '../config/constants';

export default function () {
  const isDesktop = window.matchMedia(`(min-width: ${BREAKPOINT.HAMBURGER_MENU}px)`);
  const navEl = document.querySelector(SELECTORS.NAV);

  if (!navEl) {
    return;
  }

  document.addEventListener(
    'click',
    closeActiveCollapseOnDesktop,
    true,
  );

  isDesktop.addEventListener('change', closeActiveCollapseOnDesktop);

  function closeActiveCollapseOnDesktop(ev) {
    if (isDesktop.matches) {
      closeActiveCollapse(ev);
    }
  }

  function closeActiveCollapse({ target }) {
    if (target instanceof HTMLElement) {
      const targetIsNavChild = navEl.contains(target);

      if (targetIsNavChild) {
        return;
      }
    }

    const navItemsWithChildren = [...navEl.querySelectorAll(SELECTORS.NAV_ITEM_WITH_CHILDREN)];
    const notCollapsedItem = navItemsWithChildren.find(
      (e) => !e.querySelector(`.${CLASSES.BS.COLLAPSE.COLLAPSED}`),
    );

    if (notCollapsedItem) {
      getCollapseTrigger(notCollapsedItem).dispatchEvent(new Event('click'));
    }
  }
}

function getCollapseTrigger(target) {
  return target.querySelector(`[data-${DATA_ATTR.BS.COLLAPSE_TARGET}]`);
}
